import { isCliImmediateShutdownRequested } from '../runtime/cli-process-interrupt.js';
import { yieldForBridgeInteractivePriority } from '../files/browser/in-flight.js';
import { CliSqliteInterrupted } from '../sqlite/code-nav-cache/database.js';

/** Yield while walking, parsing, or resolving symbols (keeps bridge responsive). */
export const CODE_NAV_YIELD_EVERY = 64;

export type CodeNavYieldState = { n: number };

export function createCodeNavYieldState(): CodeNavYieldState {
  return { n: 0 };
}

/** Yield periodically and throw {@link CliSqliteInterrupted} when shutdown is requested. */
export async function yieldDuringCodeNavWork(state: CodeNavYieldState): Promise<void> {
  state.n++;
  if (state.n % CODE_NAV_YIELD_EVERY !== 0) return;
  if (isCliImmediateShutdownRequested()) throw new CliSqliteInterrupted();
  await yieldForBridgeInteractivePriority();
  if (isCliImmediateShutdownRequested()) throw new CliSqliteInterrupted();
}
